import * as React from 'react';
import styled from 'styled-components';

import { CardLine } from '../ui/divider/CardLine';
import { CardImage } from './CardImage';
import { CardLinkWrapper } from './CardWrapper';
import { Button } from '../ui/button/Button';
import { Article } from '../../types';
import { DELETE_NEWS_MUTATION } from '../../../client/__graphql__/mutations/deleteNews';
import { useMutation } from '@apollo/client';
import { getAdminClient } from './admin/AdminApolloClient';
import { ConfirmBox } from '../ui/popup/ConfirmBox';
import { AdminContext } from '../containers/Admin';
import { isExternalURL, IsValidUrl } from '../../utils/helpers/url';

export const CardStyle = styled.div`
  color: ${({ theme }) => theme.colors.black};
  position: relative;
  bottom: 20px;
  background-color: ${({ theme }) => theme.colors.white};
  width: 80%;
  margin-top: -10px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 38px 30px;
  box-shadow: 0 0 20px rgb(0, 0, 0, 0.2);
  height: calc(100% - 250px);
  z-index: 2;

  h4 {
    font-size: 28px;
  }

  @media all and (min-width: 751px) and (max-width: 853px) {
    min-height: 230px;
  }
  @media all and (min-width: 1151px) {
    min-height: 230px;
  }

  @media all and (min-width: 375px) {
    p {
      font-size: 15px;
    }
  }
`;

export const CardStyleButtonWrapper = styled.div``;

const client = getAdminClient();

export const NewsCard: React.FC<{
  title: string;
  ingress: string;
  image: string;
  imageCategory?: string;
  url?: string;
  id?: any;
  showDeleteButton?: boolean;
  published?: string;
  style?: any;
  newTab?: boolean;
}> = ({
  id,
  title,
  ingress,
  image,
  imageCategory,
  url,
  showDeleteButton,
  published,
  style,
  newTab,
}) => {
  const [external] = React.useState(IsValidUrl(url));
  const context = React.useContext(AdminContext);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [is_published, SetIsPublished] = React.useState<boolean>(
    published != null && published != undefined && published.trim().length > 0
  );

  const [del, { error, loading, data }] = useMutation(DELETE_NEWS_MUTATION, {
    client,
  });

  const clickDelete = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    setShowConfirm(true);
  };
  const close = () => {
    setShowConfirm(false);
  };

  const handleDelete = (e: any) => {
    e.preventDefault();
    del({
      variables: {
        id: id,
      },
    });
    context.setAdminState({
      ...context.adminState,
      news: [
        ...context.adminState.news.filter(
          (article: Article) => article.id !== id
        ),
      ],
    });
  };

  const content = () => {
    return (
      <>
        <CardImage
          image={isExternalURL(image).link}
          description={'nyhetsbilde'}
          type={imageCategory}
        />
        <CardStyle>
          <h4>{title}</h4>
          <CardLine />
          <span dangerouslySetInnerHTML={{ __html: ingress }} />
          <CardStyleButtonWrapper style={{ zIndex: 3 }}>
            {showDeleteButton ? (
              <Button type="primary" colorTheme="gold" onClick={clickDelete}>
                Slett
              </Button>
            ) : null}
          </CardStyleButtonWrapper>
        </CardStyle>
        {showConfirm && (
          <ConfirmBox close={close} handleDelete={handleDelete} />
        )}
        {showDeleteButton && !is_published ? (
          <PublishCover>
            <PublishText>
              <span className="text">Ikke publisert</span>
            </PublishText>
          </PublishCover>
        ) : null}
      </>
    );
  };

  if (external) {
    return (
      <CardLinkWrapper
        href={url}
        as={'a'}
        style={style}
        target={newTab ? '_blank' : '_self'}
      >
        {content()}
      </CardLinkWrapper>
    );
  } else {
    return (
      <CardLinkWrapper to={url} style={style}>
        {content()}
      </CardLinkWrapper>
    );
  }
};

const PublishCover = styled.div`
  background-color: #2d2c2c;
  opacity: 0.8;
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 250px;
  font-weight: bold;
  display: flex;
`;

const PublishText = styled.div`
  margin: auto;

  span {
    color: white;
    font-size: 25px;
    display: block;
  }
`;

const GetText = (org: string) => {
  const max_length = 67;

  if (org && org.trim().length > max_length) {
    let tmp = org.replace('<p>', '').replace('</p>', '').trim();

    if (tmp.length > max_length) {
      if (tmp.endsWith('<') || tmp.endsWith('>') || tmp.endsWith('/')) {
        tmp = SubString(tmp, ' ');
      }

      return tmp.substring(0, max_length).trim();
    }
  }

  return org.trim();
};

const SubString = (value: string, key: string) => {
  if (value && value.trim().length > 0 && key && key.length > 0) {
    const tmp = value.trim();
    const indx = tmp.lastIndexOf(key);

    if (indx > -1) {
      return tmp.substring(0, indx);
    }
  }

  return value;
};

export default NewsCard;
